const PDF_CONTENT_TYPE = 'application/pdf'
const PDF_EXTENSION = '.pdf'

function getFilenameFromContentDisposition(contentDisposition) {
    if (!contentDisposition || typeof contentDisposition !== 'string') {
        return null
    }
    const parts = contentDisposition.split(';').map(p => p.trim())
    let fileNameStar = null
    let fileName = null
    for (const p of parts) {
        if (p.toLowerCase().startsWith('filename*=')) {
            fileNameStar = p.substring(9)
            break
        }
        if (p.toLowerCase().startsWith('filename=')) {
            fileName = p.substring(9)
        }
    }
    if (fileNameStar) {
        // RFC 5987: filename*=UTF-8''encoded
        const idx = fileNameStar.indexOf('\'\'')
        let encoded = fileNameStar
        if (idx > -1) {
            encoded = fileNameStar.substring(idx + 2)
        }
        try {
            return decodeURIComponent(stripQuotes(encoded)) || null
        } catch (e) {
            return stripQuotes(encoded)
        }
    }
    if (fileName) {
        return stripQuotes(fileName) || null
    }
    return null
}

function stripQuotes(value) {
    if (!value) return value
    if (value.startsWith('"') && value.endsWith('"')) {
        return value.slice(1, -1)
    }
    return value
}

function ajustarNomeParaPdf(nome, contentType) {
    if (!nome) return nome
    if (!contentType || contentType.toLowerCase() !== PDF_CONTENT_TYPE) return nome
    const endsWithPDFUpper = nome.endsWith('.PDF')
    const adjusted = endsWithPDFUpper ? nome.slice(0, -4) + PDF_EXTENSION : nome
    if (adjusted.toLowerCase().endsWith(PDF_EXTENSION)) return adjusted
    return adjusted + PDF_EXTENSION
}

function resolveDownloadFilename(response, fallbackNome) {
    const headers = response && response.headers ? response.headers : {}
    const contentDisposition = headers['content-disposition'] || headers['Content-Disposition']
    const contentType = headers['content-type'] || headers['Content-Type']
    const byHeader = getFilenameFromContentDisposition(contentDisposition)
    const base = byHeader || fallbackNome || 'download'
    return ajustarNomeParaPdf(base, contentType)
}

function resolveDownloadInfo(response, fallbackNome, defaultContentType){
    const headers = response && response.headers ? response.headers : {}
    const contentType = headers['content-type'] || headers['Content-Type'] || defaultContentType || 'application/octet-stream'
    const nome = resolveDownloadFilename(response, fallbackNome)
    return { nome, contentType }
}

export default {
    getFilenameFromContentDisposition,
    ajustarNomeParaPdf,
    resolveDownloadFilename,
    resolveDownloadInfo
}
